import React from 'react'
import Slider from 'react-slick'

const BannerCarousel = ({ items }) => {
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }

    return (
        <div style={{ width: '100%', overflow: 'hidden' }}>
            <Slider {...settings}>
                {items.map((item, index) => (
                    <div key={index} style={{ margin: 8 }}>
                        <img
                            src={item.src}
                            alt={item.alt}
                            style={{
                                width: '100%',
                                height: '250px',
                                objectFit: 'cover',
                            }}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    )
}

export default BannerCarousel
